import SubSectionHeading from "@/components/SubSectionHeading";
import AddressInput from "@/features/facility/components/ContactDetails/forms/inputs/AddressInput";

import { FormTextField, PhoneField } from "./shared";

export default function LocationContactStep() {
  return (
    <div className="flex flex-col">
      <p className="text-title-large mb-6">Enter the facility address and contact information.</p>

      <div className="flex flex-col gap-7">
        <div className="flex flex-col gap-4">
          <SubSectionHeading>Address</SubSectionHeading>
          <div className="flex flex-col gap-6">
            <AddressInput boldLabel required name="mainAddress" label="Main" />
            <AddressInput boldLabel name="mailingAddress" label="Mailing" />
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <SubSectionHeading>Phone</SubSectionHeading>
          <div className="flex flex-col gap-6">
            <PhoneField name="phone" label="Business Phone Number" required />
            <PhoneField name="fax" label="Fax Number" />
            <PhoneField name="golfShopPhone" label="Golf Shop Phone Number" />
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <SubSectionHeading>Personnel</SubSectionHeading>
          <div className="flex flex-col gap-6">
            <FormTextField className="w-full" name="generalManagerName" label="General Manager" />
            <FormTextField className="w-full" name="managementGroup" label="Management Group" />
          </div>
        </div>
      </div>
    </div>
  );
}
